jQuery.noConflict();
(function( $ ) {
  $(function() {
    // More code using $ as alias to jQuery
    
    if($('.template-index').length) {
      	$('.move-to-search').show().prependTo('#ymm_searchbox');
    }
    
    if($('.template-collection').length){
     	$('#sidebar li').each(function(){
          	var name = $(this).find('a').text();
          	var url = $(this).find('a').attr('href');
          	var li = '<li class="mobile-nav__item border-bottom"><a href="'+url+'" class="mobile-nav__sublist-link"><span class="mobile-nav__label">'+name+'</span></a></li>';
          	$('.mobileCats').append(li);
        });
    } else {
      	$('.catsLi').remove();
    }
  
    $('ul.tabs').each(function(){
        var active, 
            content, 
            links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
            $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function(e){
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return false;
        });
    });

    $('.brands-list .owl-carousel').owlCarousel({
        loop:true,
        slideBy:1,
        margin:10,
        nav:true,
        navText : ["&lsaquo;","&rsaquo;"],
        dots:false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:false
            },
            300:{
                items:2,
                nav:false
            },
            800:{
                items:5
            }
        }
    });

          
    $('.panel .owl-carousel').owlCarousel({
        loop:true,
        slideBy:4,
        margin:30,
        nav:true,
        navText : ["&lsaquo;","&rsaquo;"],
        dots:false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:false
            },
            300:{
                items:2,
                nav:false
            },
            800:{
                items:4
            }
        }
    });
   
   
  });
  
  jQuery(document).ready(checkContainer);
  
  $(window).load(function() {
    	equalheight('.product-card .product-card__title');
    	equalheight('.tabbrandsshold h3');
    	equalheight('.tabbrandsshold2 h3');
    
		if($('.emptymsg').length){
      		$('#ZlistWishlist').remove();
        } else {
          	$('#ZlistWishlist').show();
        }
  });
  
  $(window).resize(function(){
    	equalheight('.product-card .product-card__title');
    	equalheight('.tabbrandsshold h3');
    	equalheight('.tabbrandsshold2 h3');
  });
  
})(jQuery);

equalheight = function(container){

	var currentTallest = 0,
     	currentRowStart = 0,
     	rowDivs = new Array(),
     	$el,
     	topPosition = 0;
 	$(container).each(function() {

   		$el = $(this);
   		$($el).height('auto')
   		topPostion = $el.position().top;

   		if (currentRowStart != topPostion) {
     		for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       			rowDivs[currentDiv].height(currentTallest);
     		}
     		rowDivs.length = 0; // empty the array
     		currentRowStart = topPostion;
     		currentTallest = $el.height();
     		rowDivs.push($el);
   		} else {
     		rowDivs.push($el);
     		currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  		}
   		for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     		rowDivs[currentDiv].height(currentTallest);
   		}
 	});
}

function checkContainer () {
  if($('.countdown-KT').is(':visible')){ //if the container is visible on the page
    	$('.countdown-KT div:last-child a').hide();
  } else {
    	setTimeout(checkContainer, 50); //wait 50 ms, then try again
  }
}